/* @flow */

export function getTimezoneLabel(timezone: string): string {
  return timezone.replace(/_/g, ' ');
}
